define('ProductMSRPDisplay.View', [
	'productmsrpdisplay.tpl',
	'Backbone',
	'underscore'
], function (
	Template,
	Backbone,
	_
) {
	'use strict';

	return Backbone.View.extend({

		template: Template,

		initialize: function (options) {
			this.application = options.application;
			this.srp_formatted = options.srp_formatted;
			this.srp = options.srp;
			this.discount_rate = options.discount_rate;
			this.userIsLoggedIn = options.userIsLoggedIn;
		}, 
		
		getContext: function getContext() {		
			return {
				// @property {String} srpFormatted
				srpFormatted: this.srp_formatted,
				// @property {String} srp
				srp: this.srp,
				// @property {String} discountRateFormatted
				discountRate: this.discount_rate,
				// @property {String} discountRateFormatted
				discountRateFormatted: _.translate('($(0)% off)', this.discount_rate),
				// @property {Boolean} userIsLoggedIn
				userIsLoggedIn: this.userIsLoggedIn
			};
		}
	});
});
